import {
  GET_ALL_PRODUCT_FOR_INT_REQUEST,
  GET_ALL_PRODUCT_FOR_INT_SUCCESS,
  GET_ALL_PRODUCT_FOR_INT_ERROR,

} from "./types";

import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const getProductForInt = (token, data, saleOrderID, fromLocationValue) => (dispatch) => {


  let new_data = data.map((record) => {
    delete record.Id;
    // delete record.quantity;
    return {
      item_code: record.item_code.replaceAll(" ", ""),
      quantity: record.quantity
    };
  })

  dispatch({ type: GET_ALL_PRODUCT_FOR_INT_REQUEST });
  return axios({
    method: "POST",
    // url: `${BASEURL}getAll/ProductForInt`,
    url: `${BASEURL}getAll/productForInvAdj`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      data: new_data,
      fromLocationValue
    },
  })
    .then((response) => {

      return dispatch({
        type: GET_ALL_PRODUCT_FOR_INT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_ALL_PRODUCT_FOR_INT_ERROR,
        payload: error.response,
      });
    });
};


